var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"text-center"},[_vm._v("404 - puslapis nerastas")])}
var staticRenderFns = []

export { render, staticRenderFns }